/* eslint-disable promise/param-names */
import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from '../actions/auth'
import { USER_REQUEST } from '../actions/user'
// import Vue from 'vue'
import api from '@/utils/apiClient'
import {
  clearAuthSession,
  readAuthSession,
  storeAuthSession
} from '@/utils/authStorage'

const storedSession = readAuthSession()
const state = {
  token: storedSession.token || '',
  userId: storedSession.userId,
  status: '',
  hasLoadedOnce: false,
  tokenExpiresAt: storedSession.tokenExpiresAt
}

const getters = {
  isAuthenticated: state => !!(state.token && state.userId),
  authStatus: state => state.status
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    commit(AUTH_REQUEST)
    return api.post('/auth', { user: user })
      .then(response => response.data)
      .then(resp => {
        const persistedSession = storeAuthSession({
          token: resp.token,
          userId: resp.user.id
        })

        commit(AUTH_SUCCESS, {
          token: resp.token,
          user: resp.user,
          tokenExpiresAt: persistedSession.tokenExpiresAt
        })
        dispatch('setUserId', resp.user.id, { root: true })
        dispatch(USER_REQUEST).catch(() => {})
        dispatch('loadAll').catch(() => {})
        return resp
      })
      .catch(err => {
        commit(AUTH_ERROR, err)
        clearAuthSession()
        return Promise.reject(err)
      })
  },
  [AUTH_LOGOUT]: ({commit}) => {
    commit(AUTH_LOGOUT)
    clearAuthSession()
    return Promise.resolve()
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp.token
    state.profile = resp.user
    // state.user.profile = resp.user
    state.userId = resp.user.id
    state.hasLoadedOnce = true
    state.tokenExpiresAt = resp.tokenExpiresAt
    console.log('AUTH_SUCCESS')
    console.log(state.userId)
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
    state.userId = null
    state.tokenExpiresAt = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js